import _get from 'lodash/get';

import { objectToCamelCase } from '../libs/format';

export function selectFeatureSets(state) {
  return objectToCamelCase(_get(state, 'website.subscription.feature_sets'));
}
